import { MoneyType } from '@api';

export const formatCurrency = ({ value, currency }: MoneyType): string => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency,
  }).format(value);
};
